import * as Sentry from "@sentry/react";
import axios from "axios";

const MAX_REQUESTS_PER_MINUTE = 512;

let currentMinuteWindow = 0;
let count = 0;
let hitTheEmergencyBrakes = false;

axios.interceptors.request.use((config) => {
    const now = Date.now();
    const minuteWindow = Math.floor(now / 1000 / 60);
    if (minuteWindow !== currentMinuteWindow) {
        currentMinuteWindow = minuteWindow;
        count = 0;
    }
    count++;
    if (count > MAX_REQUESTS_PER_MINUTE && !hitTheEmergencyBrakes) {
        hitTheEmergencyBrakes = true;
        console.error(
            "Hit the emergency breaks on self DDoS protection. Last request: ",
            {
                url: config.url,
                method: config.method,
                data: JSON.stringify(config.data),
                headers: config.headers.toJSON(true),
            },
        );
        Sentry.captureException(
            new Error("Aborting due to self DDoS protection"),
        );
    }

    return hitTheEmergencyBrakes
        ? {
              ...config,
              signal: new AbortSignal(),
          }
        : config;
});
